import * as React from "react";
import {
  DataGrid,
  GridToolbar,
  GridFilterModel,
  GridColumnVisibilityModel,
  GridSlotsComponent,
  useGridApiRef,
} from "@mui/x-data-grid";
import { CustomDataGridProps } from "../../../interfaces/common/ui/IDataGridTable";

const QuickFilteringExcludeHiddenColumns: React.FC<
  CustomDataGridProps & { className?: string }
> = ({
  columns,
  rows,
  hideFooter,
  disableColumnFilter,
  checkboxSelection,
  disableColumnSelector,
  disableDensitySelector,
  className,
  showToolbar,
  getEstimatedRowHeight,
  getRowHeight,
  autoHeight,
  handleSelectionChange,
}) => {
  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [""],
  });

  const [columnVisibilityModel, setColumnVisibilityModel] =
    React.useState<GridColumnVisibilityModel>({
      id: false,
    });

  const apiRef = useGridApiRef();

  const slots: Partial<GridSlotsComponent> | undefined = showToolbar
    ? { toolbar: GridToolbar }
    : undefined;

  const onRowSelectionModelChange = (newSelection: any) => {
    const selectedRows = newSelection.map((id: any) =>
      apiRef.current.getRow(id)
    );

    if (handleSelectionChange) {
      handleSelectionChange(selectedRows);
    }
  };

  return (
    <>
      <DataGrid
        className={className}
        columns={columns}
        rows={rows}
        checkboxSelection={checkboxSelection}
        disableColumnFilter={disableColumnFilter}
        disableColumnSelector={disableColumnSelector}
        disableDensitySelector={disableDensitySelector}
        slots={slots}
        filterModel={filterModel}
        onFilterModelChange={(newModel: GridFilterModel) =>
          setFilterModel(newModel)
        }
        slotProps={{ toolbar: { showQuickFilter: true } }}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={(newModel: GridColumnVisibilityModel) =>
          setColumnVisibilityModel(newModel)
        }
        hideFooter={hideFooter}
        getEstimatedRowHeight={getEstimatedRowHeight}
        getRowHeight={getRowHeight}
        autoHeight={autoHeight}
        onRowSelectionModelChange={onRowSelectionModelChange}
        apiRef={apiRef}
      />
    </>
  );
};

export default QuickFilteringExcludeHiddenColumns;
